<div class="dashboard-content roles-management-page" style="padding: 120px 40px 50px">
  <div class="billing-and-payments-screen">

  <!-- Page permissions. Shown when opened from Configure on the Roles list. -->
  <div *ngIf="activeTab === 'permissions'">
    <!-- Standard page heading: title left, search + actions right -->
    <div class="page-heading">
      <h3>
        <span class="back-circle" (click)="goBack()" nz-tooltip
          [nzTooltipTitle]="'common.back' | translate">
          <i class="fa-solid fa-angle-left"></i>
        </span>
        {{ 'roles-page.tab-page-permissions' | translate }}
      </h3>
      <div class="heading-right">
        <div class="search">
          <input type="text" class="form-control" [(ngModel)]="pageSearchTerm"
            [placeholder]="'roles-page.filter-pages-placeholder' | translate" autocapitalize="off"
            style="text-transform: none;">
          <i class="fa-solid fa-magnifying-glass"></i>
          <i class="fa-solid fa-xmark clear-search" *ngIf="pageSearchTerm" (click)="pageSearchTerm = ''"
            style="cursor: pointer;"></i>
        </div>
        <button class="filter-btn" (click)="grantAll()"
          [title]="'roles-page.grant-all-tooltip' | translate">
          <i class="fa-solid fa-check-double"></i>
          <span>{{ 'roles-page.grant-all' | translate }}</span>
        </button>
        <button class="filter-btn" (click)="revokeAll()"
          [title]="'roles-page.revoke-all-tooltip' | translate">
          <i class="fa-solid fa-ban"></i>
          <span>{{ 'roles-page.revoke-all' | translate }}</span>
        </button>
        <button *ngIf="hasUnsavedChanges" class="btn btn-light filter-btn" (click)="revertChanges()"
          [title]="'roles-page.revert' | translate">
          <i class="fa-solid fa-rotate-left"></i>
          <span>{{ 'roles-page.revert' | translate }}</span>
        </button>
        <button class="btn btn-primary" (click)="promptSavePermissions()"
          [disabled]="isSavingPermissions || !hasUnsavedChanges || isUsingFallbackPages"
          [title]="'roles-page.save-permissions' | translate">
          <span *ngIf="isSavingPermissions" class="spinner-border spinner-border-sm me-2"></span>
          {{ isSavingPermissions ? ('roles-page.saving' | translate) : ('roles-page.save-permissions' | translate) }}
        </button>
      </div>
    </div>

    <!-- Page list unavailable: ids are placeholders, saving would be rejected -->
    <div *ngIf="isUsingFallbackPages" class="perm-warning mb-3">
      <i class="fa-solid fa-triangle-exclamation"></i>
      <span>
        <strong>Page list unavailable.</strong>
        The server returned no client pages, so the rows below are a local placeholder list and
        <strong>cannot be saved</strong>. Reload once the pages endpoint is available.
      </span>
    </div>

    <!-- Page Toggles Tree List -->
    <div *ngIf="!isLoadingPermissions" class="luqta-card">
      <div class="card-heading">
        <h3>{{ 'roles-page.tab-page-permissions' | translate }} ({{ allowedCount }}/{{ totalPages }})</h3>
      </div>

      <!-- nzTemplateMode keeps the parent/child tree rows while giving the table
           the same chrome every other list screen uses. -->
      <nz-table #permissionsTable [nzTemplateMode]="true" [nzBordered]="false" [nzShowPagination]="false"
        [nzScroll]="{ x: '1400px', y: 'calc(100vh - 300px)' }">
          <thead>
            <tr>
              <th nzWidth="360px" class="ps-4">
                <div class="d-flex align-items-center gap-2">
                  <span>{{ 'client-pages.col-name' | translate }}</span>
                  <button *ngIf="hasAnyChildren" class="tree-toggle-all" (click)="toggleAll()"
                    [title]="(allCollapsed ? 'client-pages.expand-all' : 'client-pages.collapse-all') | translate">
                    <i class="fa-solid" [class.fa-angles-down]="allCollapsed" [class.fa-angles-up]="!allCollapsed"></i>
                  </button>
                </div>
              </th>
              <th nzWidth="200px">{{ 'client-pages.col-key' | translate }}</th>
              <th nzWidth="240px">{{ 'client-pages.col-url' | translate }}</th>
              <th *ngFor="let action of permissionActions" class="text-center perm-col-head" nzWidth="135px">
                <div class="perm-col-inner">
                  <div class="perm-col-title" nz-tooltip [nzTooltipTitle]="action.hint">
                    <i [class]="action.icon"></i>
                    <span>{{ getActionLabel(action) }}</span>
                  </div>
                  <div class="perm-col-meta">
                    <span class="perm-col-count">{{ countForAction(action) }}/{{ totalPages }}</span>
                    <button type="button" class="perm-col-btn grant" (click)="toggleColumn(action, true)" nz-tooltip
                      [nzTooltipTitle]="'roles-page.grant-action-all' | translate: { action: getActionLabel(action) }">
                      <i class="fa-solid fa-check"></i>
                    </button>
                    <button type="button" class="perm-col-btn revoke" (click)="toggleColumn(action, false)" nz-tooltip
                      [nzTooltipTitle]="'roles-page.revoke-action-all' | translate: { action: getActionLabel(action) }">
                      <i class="fa-solid fa-xmark"></i>
                    </button>
                  </div>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let parent of filteredTreePages">
              <!-- Parent Row -->
              <tr class="parent-row">
                <td class="ps-4 py-3">
                  <div class="tree-cell">
                    <button *ngIf="parent.children && parent.children.length > 0" class="tree-chevron"
                      (click)="toggleCollapse(parent.page_id, $event)"
                      [title]="(isCollapsed(parent.page_id) ? 'client-pages.expand' : 'client-pages.collapse') | translate">
                      <i class="fa-solid fa-chevron-down" [class.collapsed]="isCollapsed(parent.page_id)"></i>
                    </button>
                    <span *ngIf="!parent.children || parent.children.length === 0" class="tree-chevron-spacer"></span>

                    <div class="page-avatar">
                      <i class="fa-solid fa-folder-open"></i>
                    </div>

                    <span class="page-name">{{ getPageDisplayName(parent) }}</span>

                    <span *ngIf="parent.children && parent.children.length > 0" class="children-pill"
                      (click)="toggleCollapse(parent.page_id, $event)"
                      [title]="(isCollapsed(parent.page_id) ? 'client-pages.expand' : 'client-pages.collapse') | translate">
                      <i class="fa-solid fa-network-wired"></i>
                      {{ parent.children.length }} {{ 'roles-page.sub-pages' | translate }}
                    </span>

                    <button type="button" class="row-all-btn" (click)="toggleRow(parent, !isRowFullyGranted(parent))"
                      nz-tooltip
                      [nzTooltipTitle]="(isRowFullyGranted(parent) ? 'roles-page.row-revoke-all' : 'roles-page.row-grant-all') | translate">
                      <i class="fa-solid" [class.fa-check-double]="!isRowFullyGranted(parent)"
                        [class.fa-ban]="isRowFullyGranted(parent)"></i>
                    </button>
                  </div>
                </td>
                <td class="py-3">
                  <code class="key-chip" [title]="parent.page_key">{{ getPageKeyLabel(parent) }}</code>
                </td>
                <td class="py-3">
                  <span class="url-text" [title]="parent.url">{{ getPageUrlLabel(parent) }}</span>
                </td>
                <td *ngFor="let action of permissionActions" class="text-center py-3">
                  <nz-switch [(ngModel)]="parent[action.field]" (ngModelChange)="onToggleAction(parent, action)"
                    [nzDisabled]="isActionDisabled(parent, action)" nzSize="small"></nz-switch>
                </td>
              </tr>

              <!-- Children Rows (Nested Tree) -->
              <ng-container *ngIf="!isCollapsed(parent.page_id)">
                <tr *ngFor="let child of visibleChildren(parent); let isLast = last" class="child-row">
                  <td class="ps-4 py-3">
                    <div class="tree-cell indented">
                      <span class="tree-branch" [class.last]="isLast"></span>
                      <span class="tree-chevron-spacer"></span>

                      <div class="page-avatar child">
                        <i class="fa-solid fa-file-lines"></i>
                      </div>

                      <span class="page-name child">{{ getPageDisplayName(child) }}</span>

                      <button type="button" class="row-all-btn" (click)="toggleRow(child, !isRowFullyGranted(child))"
                        nz-tooltip
                        [nzTooltipTitle]="isRowFullyGranted(child) ? 'Revoke all actions on this page' : 'Grant all actions on this page'">
                        <i class="fa-solid" [class.fa-check-double]="!isRowFullyGranted(child)"
                          [class.fa-ban]="isRowFullyGranted(child)"></i>
                      </button>
                    </div>
                  </td>
                  <td class="py-3">
                    <code class="key-chip" [title]="child.page_key">{{ getPageKeyLabel(child) }}</code>
                  </td>
                  <td class="py-3">
                    <span class="url-text" [title]="child.url">{{ getPageUrlLabel(child) }}</span>
                  </td>
                  <td *ngFor="let action of permissionActions" class="text-center py-3">
                    <nz-switch [(ngModel)]="child[action.field]" (ngModelChange)="onToggleAction(child, action)"
                      [nzDisabled]="isActionDisabled(child, action)" nzSize="small"></nz-switch>
                  </td>
                </tr>
              </ng-container>
            </ng-container>

            <tr *ngIf="filteredTreePages.length === 0">
              <td [attr.colspan]="3 + permissionActions.length" class="text-center py-5 text-muted">
                <i class="fa-solid fa-filter text-muted mb-2" style="font-size: 28px;"></i>
                <div>{{ 'roles-page.no-pages-match' | translate:{ term: pageSearchTerm } }}</div>
              </td>
            </tr>
          </tbody>
      </nz-table>
    </div>
  </div>

  <!-- Assign sub-users. Shown when opened from the assign action or from
       User Management, both of which pass ?tab=users. -->
  <div *ngIf="activeTab === 'users'">
    <!-- Standard page heading -->
    <div class="page-heading">
      <h3>
        <span class="back-circle" (click)="goBack()" nz-tooltip
          [nzTooltipTitle]="'common.back' | translate">
          <i class="fa-solid fa-angle-left"></i>
        </span>
        {{ 'roles-page.tab-assign-subusers' | translate }}
      </h3>
      <div class="heading-right">
        <div class="search">
          <input type="text" class="form-control" [(ngModel)]="userSearchTerm"
            [placeholder]="'roles-page.search-subusers-placeholder' | translate" autocapitalize="off"
            style="text-transform: none;">
          <i class="fa-solid fa-magnifying-glass"></i>
          <i class="fa-solid fa-xmark clear-search" *ngIf="userSearchTerm" (click)="userSearchTerm = ''"
            style="cursor: pointer;"></i>
        </div>
      </div>
    </div>

    <!-- Sub-Users Assignment Table -->
    <div *ngIf="!isLoadingUsers" class="luqta-card">
      <div class="card-heading">
        <h3>{{ 'roles-page.tab-assign-subusers' | translate }} ({{ filteredSubUsers.length }})</h3>
      </div>

      <nz-table #subUsersTable [nzData]="filteredSubUsers" [nzBordered]="true" [nzFrontPagination]="false"
        [nzShowPagination]="false" [nzScroll]="{ x: '900px', y: 'calc(100vh - 320px)' }">
          <thead>
            <tr>
              <th nzWidth="300px">{{ 'roles-page.col-subuser' | translate }}</th>
              <th nzWidth="280px">{{ 'roles-page.col-email' | translate }}</th>
              <th nzWidth="320px" class="text-center">{{ 'roles-page.col-assigned-role' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let user of subUsersTable.data">
              <td>
                <div class="d-flex align-items-center gap-3">
                  <div
                    class="rounded-circle d-flex align-items-center justify-content-center text-white font-weight-bold"
                    style="width: 38px; height: 38px; background: #5304FB; font-size: 13px;">
                    {{ user.name.charAt(0).toUpperCase() }}
                  </div>
                  <div>
                    <strong style="color: #1E005E; font-size: 14px;">{{ user.name }}</strong>
                    <div class="text-muted small">{{ 'roles-page.id-prefix' | translate }}: #{{ user.id }}</div>
                  </div>
                </div>
              </td>
              <td class="text-muted small">
                {{ user.email }}
              </td>
              <td>
                <div class="d-flex align-items-center gap-2 role-select-wrapper"
                  style="max-width: 290px; margin-inline: auto;">
                  <!-- See onSubUserRoleChange(): nzOpen is controlled so a pick closes the
                       popup on the same click, and nzDisabled no longer flips mid-click. -->
                  <nz-select class="role-select-dropdown w-100" [ngModel]="user.role_id"
                    (ngModelChange)="onSubUserRoleChange(user, $event)"
                    [nzOpen]="!!user.roleDropdownOpen" (nzOpenChange)="user.roleDropdownOpen = $event"
                    [nzCustomTemplate]="roleDisplayTemplate" nzDropdownClassName="role-dropdown-popup"
                    [nzOptionHeightPx]="46" [nzOptionOverflowSize]="8"
                    [nzPlaceHolder]="'roles-page.select-policy-role' | translate">
                    <nz-option [nzValue]="0" [nzLabel]="'roles-page.no-role-denied' | translate" nzCustomContent>
                      <div class="d-flex align-items-center gap-2 py-1">
                        <span class="role-status-dot role-status-denied"></span>
                        <span class="role-option-text role-option-denied">{{ 'roles-page.no-role-denied' | translate
                          }}</span>
                      </div>
                    </nz-option>
                    <nz-option *ngFor="let r of rolesList" [nzValue]="r.id" [nzLabel]="getRoleDisplayName(r)"
                      nzCustomContent>
                      <div class="d-flex align-items-center justify-content-between gap-2 w-100 py-1">
                        <div class="d-flex align-items-center gap-2">
                          <span class="role-status-dot role-status-active"></span>
                          <span class="role-option-text font-weight-500">{{ getRoleDisplayName(r) }}</span>
                        </div>
                        <span class="badge badge-custom"
                          style="font-size: 11px; padding: 2px 7px; background: #EAE4FF; color: #5304FB; border-radius: 12px;">
                          #{{ r.id }}
                        </span>
                      </div>
                    </nz-option>
                  </nz-select>

                  <ng-template #roleDisplayTemplate let-selected>
                    <div class="d-flex align-items-center gap-2 text-truncate" *ngIf="selected.nzValue === 0">
                      <span class="role-status-dot role-status-denied"></span>
                      <span style="color: #667085; font-size: 13px; font-weight: 500;">{{ 'roles-page.no-role-denied' |
                        translate }}</span>
                    </div>
                    <div class="d-flex align-items-center gap-2 text-truncate" *ngIf="selected.nzValue !== 0">
                      <span class="role-status-dot role-status-active"></span>
                      <span style="color: #1E005E; font-weight: 600; font-size: 13px;">{{ selected.nzLabel }}</span>
                      <span class="badge badge-custom ms-1"
                        style="font-size: 10px; padding: 1px 6px; background: #EAE4FF; color: #5304FB; border-radius: 8px;">
                        #{{ selected.nzValue }}
                      </span>
                    </div>
                  </ng-template>

                  <span *ngIf="user.isUpdating" class="spinner-border spinner-border-sm text-primary flex-shrink-0"
                    role="status" style="color: #5304FB !important;"></span>
                </div>
              </td>
            </tr>

            <tr *ngIf="filteredSubUsers.length === 0">
              <td colspan="3" class="text-center py-5 text-muted">
                <i class="fa-solid fa-users-slash text-muted mb-2" style="font-size: 32px;"></i>
                <div>{{ 'roles-page.no-subusers-found' | translate }}</div>
              </td>
            </tr>
          </tbody>
      </nz-table>
    </div>
  </div>

  </div>
</div>